import type { RouteLocationNormalized } from 'vue-router'
import { setOriginCtaUrlInLocalStorage } from '~/utils/originCtaUrl'

/**
 * Indique si un chemin appartient au flux d'inscription (`/login`, `/register` ou tunnel SEA).
 * @param {string} path - Chemin de route à tester.
 * @returns {boolean} `true` si le chemin fait partie du flux.
 */
function isRegisterFlowPath(path: string): boolean {
  return path.includes('/login') || path.includes('/register') || path.includes('/landing-page/')
}

/**
 * Mémorise la page d'origine à la première entrée dans le flux d'inscription depuis une
 * page extérieure (capture tous les CTA en un seul point).
 */
export default defineNuxtPlugin((): void => {
  const router = useRouter()
  router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized): void => {
    if (isRegisterFlowPath(to.path) && !isRegisterFlowPath(from.path) && from.matched.length > 0) {
      setOriginCtaUrlInLocalStorage(window.location.origin + from.fullPath)
    }
  })
})
